var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WebView',{attrs:{"src":_vm.srcReal,"height":_vm.height},on:{"loadStarted":_vm.loadStarted,"loadFinished":_vm.loadFinished}})
}
var staticRenderFns = []

export { render, staticRenderFns }